import { provideStates } from '@ngxs/store';
import { ClientIntakeResponsesState } from './state/clientIntakeResponses.firebase.state';
import { CurrentClientIntakeResponseState } from './state/currentClientIntakeResponse.firebase.state';

export const PROVIDE_CLIENT_INTAKE_RESPONSES_STATE = [
	provideStates([ClientIntakeResponsesState]),
];

export const PROVIDE_CURRENT_CLIENT_INTAKE_RESPONSE_STATE = [
	provideStates([CurrentClientIntakeResponseState]),
];
